import { render, staticRenderFns } from "./ApprovalDialog.vue?vue&type=template&id=17477b1a&scoped=true&lang=pug"
import script from "./ApprovalDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalDialog.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDialog.vue?vue&type=style&index=0&id=17477b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17477b1a",
  null
  
)

export default component.exports